import { Component, Fragment } from "react";
import AppManager from "../../managers/AppManager";
import UserManager from "../../managers/UserManager";
import SideBarService from "../../services/sidebar";
import Tenant from "../../services/tenant";
import TenantManager from "../../managers/TenantManager";
import { showToast, TOAST_TYPE, DKSidebar } from "deskera-ui-library";
import IAM from "../../services/iam";
import {
  CONTRACTOR,
  INTEGRATION_SETTING,
  NAVIGATIONS,
  EXPENSE_INTEGRATION_SETTING,
  CHECK_DESIGN,
  EXPENSES,
  EMPLOYEE_HIRING_ADMIN,
  OWNER_ADMIN,
  OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN,
  OWNER_ADMIN_HIRING_ADMIN,
  OWNER_ADMIN_MANAGER,
  ASSESSMENT_REVIEW,
} from "../../managers/common/RouteAuth";
import { TenantService, TENANT } from "../../managers/TenantManagerService";
import { isMobileWebView, isViewportLarge } from "../../utility/ViewportSizeUtils";
import { LeftMenuUpdate } from "./LeftMenuService";
import { withTranslation } from 'react-i18next';
import AddNewTenant from "../common/AddNewTenant";
import Popup from "../common/Popup";
import ApiConstants from "../../constants/ApiConstants";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import { connect } from 'react-redux';
import { isModuleRestricted } from "../module-access-control/ModuleAccessControlConstants";
import { COUNTRY } from "../../constants/CountryConstant";
import { isUSStateComplianceEnabled } from "../compliance/us/ConstantsUS";

class LeftMenu extends Component {
    constructor(props) {
        super(props);
        window.addEventListener("onSideBarLoad", this.handlerSidebarLoad);
        const currentPath = props.location?.pathname;
        this.state = {
            isMenuExpanded: isViewportLarge(),
            selectedTenantDetails: {
                tenantName: UserManager.getUserTenantName(),
                tenantId: UserManager.getUserTenantID(),
            },
            isSideBarLoad:false,
            tenantList: [],
            isLeftMenuUpdate:false,
            showAddTenantPopup: false,
            isAdmin: TenantService.get(TENANT.IS_ADMIN)
        };

        this.navigationRoutes = this.getActiveNavigationRoutes(TenantService.get(TENANT.IS_ADMIN))

    }

    isNavEnabled(nav, countryCode, isAdmin) {
        const isOwner = TenantService.get(TENANT.IS_OWNER);
        const isHiringAdmin = TenantService.get(TENANT.IS_HIRING_ADMIN);
        const isContractor = TenantService.get(TENANT.IS_CONTRACTOR);
        const environment = ApiConstants.CURRENT_ENVIRONMENT;

        const countryCheck = nav?.country?.includes("-1") || nav?.country?.includes(countryCode);
        if (!countryCheck) {
            return false;
        }

        const environmentCheck = nav.environment === undefined || nav.environment.includes("-1") || nav.environment.includes(environment);
        if (!environmentCheck) {
            return false;
        }

        const ACTIONS = [ACTION.VIEW, ACTION.CREATE, ACTION.EDIT, ACTION.DELETE, ACTION.EXPORT, ACTION.IMPORT, ACTION.SUBMIT];
        const hasMultiModuleAccess = PermissionUtils.hasMultiModuleAccess(nav.accessToModule, ACTIONS, nav.hasEachAccess);
        const contractorCheck = !isContractor && nav.accessTo === OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN;
        if (contractorCheck) {
            return true;
        }

        const permissionCheck = nav.accessToModule && !isHiringAdmin && !isOwner && hasMultiModuleAccess;
        if (permissionCheck) {
            return true;
        }

        if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) && PermissionUtils.hasAccessPermissisonForPWUsers(nav, null)) {
            return true;
        }

        let hasRoleAccess = false;
        if (isOwner) {
            hasRoleAccess =
                nav.accessTo === OWNER_ADMIN ||
                nav.accessTo === OWNER_ADMIN_HIRING_ADMIN ||
                nav.accessTo === OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN ||
                nav.accessTo === OWNER_ADMIN_MANAGER;
        } else if (isAdmin) {
            if (
                nav.accessTo === OWNER_ADMIN ||
                nav.accessTo === OWNER_ADMIN_HIRING_ADMIN ||
                nav.accessTo === OWNER_ADMIN_EMPLOYEE_HIRING_ADMIN ||
                nav.accessTo === OWNER_ADMIN_MANAGER
            ) {
                hasRoleAccess = true;
                if (!PermissionUtils.isDefaultRoleAssigned()) {
                    hasRoleAccess = permissionCheck;
                }
            }
        } else if (isHiringAdmin) {
            hasRoleAccess = nav.accessTo === OWNER_ADMIN_HIRING_ADMIN || nav.accessTo === EMPLOYEE_HIRING_ADMIN;
        } else if (isContractor) {
            hasRoleAccess = nav.accessTo === CONTRACTOR;
        } else {
            hasRoleAccess = nav.accessTo === EMPLOYEE_HIRING_ADMIN;
        }

        return hasRoleAccess;
    }

    deepCloneNavs(NAVIGATIONS) {
        const NAVS = [];
        NAVIGATIONS.forEach((navigation) => {
            const nav = {...navigation};
            if (Array.isArray(nav.subItems)) {
                const subItems = [];
                nav.subItems.forEach((subNav) => {
                    subItems.push({...subNav});
                });
                nav.subItems = subItems;
            }
            NAVS.push(nav);
        });

        return NAVS;
    }

    getActiveNavigationRoutes(isAdmin) {
        const countryCode = TenantService.get(TENANT.COUNTRY_CODE);
        const activeNavigationRoutes = [];
        const navgations = this.getFilteredNavigations(this.deepCloneNavs(NAVIGATIONS),isAdmin);
        const accessControlData = Array.isArray(this.props?.moduleAccessControl) ? this.props.moduleAccessControl : [];

        navgations.forEach((nav) => {
            if (!nav.hide && this.isNavEnabled(nav, countryCode, isAdmin) && !isModuleRestricted(accessControlData, nav)) {
                nav.name = this.props.t(nav.name);
                activeNavigationRoutes.push(nav);
                if (nav.subItems && nav.subItems.length > 0) {
                    const subItems = [];
                    nav.subItems.forEach((sr) => {
                        if (!sr.hide && this.isNavEnabled(sr, countryCode, isAdmin)) {
                            sr.name = this.props.t(sr.name);
                            subItems.push(sr);
                        }
                    });

                    nav.subItems = subItems;
                }
            }
        });

        return activeNavigationRoutes;
    }

    getFilteredNavigations(navgations,isAdmin) {
        const ERP_INTEGATION_SETTING = TenantService.get(TENANT.ERP_INTEGATION_SETTING);
        if (ERP_INTEGATION_SETTING) {
            const csIndex = navgations.findIndex(nav => nav.id == 'COMPANY_SETTINGS')
            if (csIndex != -1) {
                const subNav = navgations[csIndex].subItems
                const isIndex = subNav.findIndex(sNav => sNav.id == 'INTEGRATION_SETTINGS')
                if (isIndex == -1) {
                    const obj = INTEGRATION_SETTING
                    obj.hide = false
                    subNav.push(obj)
                }
            }

            const expenseIndex = navgations.findIndex((nav) => nav.id == "EXPENSE");
            if(expenseIndex != -1 && ApiConstants.IS_EXPENSES_ENABLED === "true") {
                navgations[expenseIndex] = EXPENSES;
            } else if (expenseIndex != -1) {
              const subNav = navgations[expenseIndex].subItems;
              const isIndex = subNav.findIndex(
                (sNav) => sNav.id == "EXPENSE_INTEGRATION_SETTINGS"
              );
              if (isIndex == -1) {
                const obj = EXPENSE_INTEGRATION_SETTING;
                obj.hide = !((TenantService.get(TENANT.IS_ADMIN) || PermissionUtils.hasAccess(MODULE.EXPENSE_INTEGRATION_SETTING,[ACTION.VIEW])) && UserManager.hasBooksAccess());
                subNav.push(obj);
              }
            }
        }

        const companySettings = navgations.find((nav) => nav.id === "COMPANY_SETTINGS");
        if (Array.isArray(companySettings?.subItems)) {
            if (!isMobileWebView() && TenantService.get(TENANT.IS_DIRECT_PAY_ENABLED)) {
                const index = companySettings.subItems.findIndex(sNav => sNav.id === 'CHECK_DESIGN');
                if (index === -1) {
                    companySettings.subItems.push({
                        ...CHECK_DESIGN,
                        hide: false
                    });
                }
            } else {
                const index = companySettings.subItems.findIndex(sNav => sNav.id === 'CHECK_DESIGN');
                if (index !== -1) {
                    companySettings.subItems[index].hide = true;
                }
            }

            if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US) {
                const bankAccountsIndex = companySettings?.subItems.findIndex(sNav => sNav.id === 'BANK_ACCOUNTS');
                if (bankAccountsIndex !== -1) {
                    companySettings.subItems[bankAccountsIndex].hide = !isUSStateComplianceEnabled(TenantService.get(TENANT.STATE_CODE));
                }

                const fillingAuthIndex = companySettings?.subItems.findIndex(sNav => sNav.id === 'FILLING_AUTHORIZATION');
                if (fillingAuthIndex !== -1) {
                    companySettings.subItems[fillingAuthIndex].hide = !isUSStateComplianceEnabled(TenantService.get(TENANT.STATE_CODE));
                }            
            }

            companySettings.subItems.forEach((sNav) => {
                switch (sNav.id) {
                    case "PAYSLIP_DESIGN":
                        sNav.hide = !PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, ACTION.EDIT);
                        break;
                    case "MANAGE_LOCATION":
                    case "INTEGRATION_SETTINGS":
                        sNav.hide = !UserManager.hasBooksAccess();
                        break;
                    default:
                        break;
                }
            });
        }

        const isReviewManager = TenantService.get(TENANT.APPRAISAL_REPORTING_MANAGER);

        const selfAssessment = navgations.find((nav) => nav.id === "SELF_ASSESSMENT");
        if (selfAssessment?.subItems?.length > 0 && !isAdmin) {
            if (!isMobileWebView() && isReviewManager) {
                const index = selfAssessment?.subItems.findIndex(sNav => sNav.id === 'ASSESSMENT_REVIEW');
                if (index === -1) {
                    selfAssessment.subItems.push({
                        ...ASSESSMENT_REVIEW,
                        hide: false
                    });
                } else {
                    if (index !== -1) {
                        selfAssessment.subItems[index].hide = false;
                    }
                }
            } else {
                const index = selfAssessment?.subItems.findIndex(sNav => sNav.id === 'ASSESSMENT_REVIEW');
                if (index !== -1) {
                    selfAssessment.subItems[index].hide = true;
                }
            }

        }
        return navgations
    }

    componentDidMount() {
        Promise.all([Tenant.getAllTenants(), Tenant.getAllClientTenants()]).then(
            (response) => {
                const tenantList = TenantManager.getAllTenants();

                if (response[1]) {
                    TenantManager.setAllClientTenants(response[1]);
                    response[1]?.forEach((t) => {
                        tenantList.push({
                            ...t,
                            tenantName: t.tenantName + ' ' + '<span class="fw-b">(Client)</span>'
                        });
                    });
                }

                // Use organization name from tenant list instead of token
                let selectedTenantDetails;
                if (Array.isArray(tenantList)) {
                    tenantList.forEach((t) => {
                        if (t.tenantId === UserManager.getUserTenantID()) {
                            selectedTenantDetails = {
                                tenantId: t.tenantId,
                                tenantName: t.tenantName
                            }
                        }
                    });
                }

                this.setState({
                    tenantList: tenantList,
                    selectedTenantDetails: selectedTenantDetails || this.state.selectedTenantDetails
                });
            }, (error) => {
                console.log(error);
            }
        );

        window.addEventListener("onSideBarChange", this.handleSidebarToggle);
        window.addEventListener("resize", this.handleSidebarOnResize);
        LeftMenuUpdate.getMessage().subscribe(response=>{
            this.navigationRoutes = this.getActiveNavigationRoutes(TenantService.get(TENANT.IS_ADMIN))
            this.setState({
                isLeftMenuUpdate: !this.state.isLeftMenuUpdate
            })
        })
    }

    handlerSidebarLoad = () =>{
        this.setState({isSideBarLoad: true})
    }

    componentWillUnmount() {
        window.removeEventListener('onSideBarLoad', this.handlerSidebarLoad);
        window.removeEventListener("onSideBarChange", this.handleSidebarToggle);
        window.removeEventListener("resize", this.handleSidebarOnResize);
    }

    handleSidebarOnResize() {
        SideBarService.setIsSideBarExpanded();
        SideBarService.triggerSidebarChangeEvent();
    }

    handleSidebarToggle = () => {
        this.setState({ isMenuExpanded: SideBarService.isSideBarExpanded });
    };

    onSaveNewTenantTapped = (newTenantName) => {
        Tenant.getOrgWithoutSetup({
            tenantName: newTenantName,
            isBookkeeper: false,
            refreshToken: "refreshToken",
        }).then((res) => {
            IAM.switchTenant({ tenantId: res.tenantId }).then((res) => {
                window.location.reload();
            });
        });
    }

    onSelectTenant = (newSelectedTenantDetails) => {
        if (
            newSelectedTenantDetails.tenantId !==
            this.state.selectedTenantDetails.tenantId
        ) {
            IAM.switchTenant({ tenantId: newSelectedTenantDetails.tenantId }).then(
                (res) => {
                    AppManager.refreshApp();
                },
                (err) => { }
            );
        } else {
            showToast("Current organisation", TOAST_TYPE.SUCCESS);
        }
    }

    render() {
        return (
            <Fragment>
                <div
                    className={`transparent-background parent-height parent-width position-absolute ${
                        this.state.isMenuExpanded
                            ? "display-only-mobile z-index-5"
                            : "display-none z-index-0"
                    }`}
                    onClick={() => SideBarService.toggleSideBar()}
                ></div>
                <DKSidebar
                    className="z-index-6"
                    collapsedWidth={0}
                    expandedWidth={230}
                    allowTenantSelection={!isMobileWebView()}
                    menuItemList={this.navigationRoutes}
                    tenantList={this.state.tenantList}
                    isMenuExpanded={this.state.isMenuExpanded}
                    selectedTenantDetails={this.state.selectedTenantDetails}
                    onAddNewTenantTapped={(data) =>
                        this.setState({ showAddTenantPopup: true })
                    }
                    onTenantSelect={(newTenantDetails) =>
                        this.onSelectTenant(newTenantDetails)
                    }
                    onExpandCollapse={() => SideBarService.toggleSideBar()}
                    allowAddTenant={this.state.isAdmin}
                />
                {this.state.showAddTenantPopup && (
                    <Popup popupWindowStyles={{ overflow: "visible" }}>
                        <AddNewTenant
                            onClose={() => this.setState({ showAddTenantPopup: false })}
                            onSave={(data) => this.setState({ showAddTenantPopup: false })}
                        />
                    </Popup>
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    moduleAccessControl: state.moduleAccessControl?.data
});

export default connect(mapStateToProps)(withTranslation()(LeftMenu));
